(function ($, Cobalt, undefined) {
    Cobalt.Avatar = {
        initialize: function () {
            $("form.avatar-form").each(function () {
                var $form = $(this);
                $form.ajaxForm({
                    type: 'post',
                    iframe: true,
                    dataType: 'json',
                    beforeSubmit: function () {
                        if (!$form.valid()) {
                            return false;
                        }
                        else {
                            $form.mask();
                        }
                    },
                    success: function (data, textStatus, xhr) {
                        switch (data.result) {
                            case "success":
                                parent.location.reload();
                                break;
                            case "invalid":
                                $form.unmask();
                                Cobalt.Forms.displayErrors($form, data.errors);
                                break;
                            default:
                                $form.unmask();
                                throw "Unknown data result from upload avatar form: " + data.result.toString();
                        }
                    },
                    error: function (XMLHttpRequest, textStatus, errorThrown) {
                        $form.unmask();
                    }
                });
            });
        }
    }
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Avatar.js